module.exports = __webpack_public_path__ + "img/dashboard.76c68c28.svg";